/**
 * Shared route builders for vendor-facing DTA links. Kept in one place so the DTA table and the
 * insights panel produce identical paths and stay in sync.
 */

/**
 * Path to a DTA's details page. Includes the version segment when a version is known.
 */
export const dtaDetailsPath = (dtaId: string, version?: string): string =>
  version ? `/dtas/${dtaId}/v/${version}` : `/dtas/${dtaId}`

/**
 * Path to the vendor data-submission page for a specific DTA version.
 */
export const vendorSubmitPath = (dtaId: string, version: string): string =>
  `/vendor/submit/${dtaId}?version=${version}`
